// title  标题
// tabbar: true 底部导航栏展示
// unpull: true 禁用下拉刷新
// unback: true, 不展示返回顶部按钮
// noheader: true 没有顶部
export default [
  {
    path: "game/library",
    name: "game.library",
    meta: {
      title: "游戏库",
      tabbar: true,
      unback: true,
      noheader: true,
      unpull: true,
    },
    component: () => import("./GameLibrary.vue"),
  },
  {
    path: "game/search",
    name: "game.search",
    meta: {
      title: "搜索",
      unback: true,
      noheader: true,
      unpull: true,
    },
    component: () => import("./SearchGames.vue"),
  },
  {
    path: "game/myGames",
    name: "game.myGames",
    meta: {
      title: "我的游戏",
      unback: true,
      noheader: true,
      unpull: true,
    },
    component: () => import("./MyGames.vue"),
  },
  {
    path: "game/detail",
    name: "game.detail",
    meta: {
      title: "游戏详情",
      // unback: true,
      // noheader: true,
      unpull: true,
    },
    component: () => import("./GameDetail.vue"),
  },
  {
    path: "game/playing",
    name: "game.playing",
    meta: {
      title: "云玩",
      unback: true,
      noheader: true,
      unpull: true,
    },
    component: () => import("./GamePlaying.vue"),
  },
  {
    path: "game/myGift",
    name: "game.myGift",
    meta: {
      title: "礼包",
      unback: true,
      noheader: true,
      unpull: true,
    },
    component: () => import("./MyGamesGift.vue"),
  },
  {
    path: "game/transferList",
    name: "game.transferList",
    meta: {
      title: "传输列表",
      unback: true,
      noheader: true,
      unpull: true,
    },
    component: () => import("./TransferList.vue"),
  },
  {
    path: "game/gameInstall",
    name: "game.gameInstall",
    meta: {
      title: "安装游戏",
      unback: true,
      noheader: true,
      unpull: true,
    },
    component: () => import("./GameInstall.vue"),
  },
  {
    path: "game/InstallProcess",
    name: "game.InstallProcess",
    meta: {
      title: "安装设备列表",
      unback: true,
      noheader: true,
      unpull: true,
    },
    component: () => import("./InstallProcess.vue"),
  },
  {
    path: "game/UpFileList",
    name: "game.upfilelist",
    meta: {
      title: "安装设备列表",
      unback: true,
      noheader: true,
      unpull: true,
    },
    component: () => import("./UpFileList.vue"),
  },
];
